import React, { useEffect, useState } from 'react';

const PagePreloader = ({ destination, onPreloadComplete, children }) => {
    const [isPreloading, setIsPreloading] = useState(false);
    const [preloadProgress, setPreloadProgress] = useState(0);

    const preloadPage = async (path) => {
        setIsPreloading(true);
        setPreloadProgress(0);

        // Simulate preloading process
        const steps = [
            { progress: 30, delay: 50 },
            { progress: 60, delay: 100 },
            { progress: 100, delay: 50 }
        ];

        for (const step of steps) {
            await new Promise(resolve => setTimeout(resolve, step.delay));
            setPreloadProgress(step.progress);
        }

        // Small delay to ensure everything is ready
        await new Promise(resolve => setTimeout(resolve, 100));
        
        setIsPreloading(false);
        onPreloadComplete();
    };

    useEffect(() => {
        if (destination) {
            preloadPage(destination);
        }
    }, [destination]);

    if (!isPreloading) {
        return children;
    }

    return (
        <div className="page-preloader">
            <div className="preloader-content">
                <div className="preloader-spinner"></div>
                <p>Loading...</p>
                <div className="preloader-progress">
                    <div 
                        className="preloader-progress-bar" 
                        style={{ width: `${preloadProgress}%` }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default PagePreloader; 